import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { InstitutionEnrollmentService } from '../../shared-services/services/institution-enrollment.service';
import { SnackBarService } from '../../shared-services/services/snack-bar.service';
import {GlobalCTATrackerService} from "../../shared-services/services/global-cta-tracker.service";

@Component({
    selector: 'app-fiserv-webhook-add-account',
    templateUrl: './fiserv-webhook.component.html',
    styleUrls: ['./fiserv-webhook.component.scss'],
    standalone: false
})
export class FiservWebhookAddAccountComponent implements OnInit {

  public flId: string;
  public enrollmentId: string;
  public action: string;
  public fdaWebHookCall$: Observable<any>;
  public showButton = false;

  constructor(private institutionEnrollmentService: InstitutionEnrollmentService,
              private snackBar: SnackBarService,
              private globalCTATrackerService: GlobalCTATrackerService) { }

  ngOnInit(): void {
    this.callFdaWebhookApi();
  }

  public callFdaWebhookApi() {
    if (window.location.href.includes('action=cancel') ||
        window.location.href.includes('errorCode')) {
        parent.postMessage({
            code: 'cancel-fiserv-widget'
        }, '*');
        this.institutionEnrollmentService.isEnrolling = false;
    } else {
        const pathSegments = window.location.href.split('/');

        this.flId = pathSegments[pathSegments.length - 3];
        this.enrollmentId = pathSegments[pathSegments.length - 2];
        this.action = pathSegments[pathSegments.length - 1];
        this.fdaWebHookCall$ = this.institutionEnrollmentService.callFdaWebhookAddAccountsApi(this.flId,
                                        this.enrollmentId, this.action);

        this.fdaWebHookCall$.subscribe(event => {
            this.globalCTATrackerService.eventTrackerV2('Account Enrollment', 'add_accounts_load_page_viewed', 'Account Enrollment');
        });
    }
  }
}
